import appStore from "store";
import api from "./api";
import {
  STATUS_TYPE,
  DEPOSIT_STATUS_TYPE,
  ALL_DEPOSIT_ENSURED,
} from "./constants";

const store = {
  namespaced: true,
  state: {
    configInfo: {
      auditTel: "",
      largeAmount: "",
      mortgageSwitch: true,
      operateTel: "",
      riskStep: "",
      userOrderLimit: "",
    },
    coinConfListInfo: [],
    preceptListInfo: [],
    preceptListTotal: NaN,
    coinConfListTotal: NaN,
    accountListInfo: [],
    accountListTotal: NaN,
    preceptDataListInfo: [],
    orderListInfo: [],
    orderListTotal: NaN,
    blastListInfo: [],
    blastListTotal: NaN,
    orderDetail: {},

    //全币种合约--begin
    contractAccountListInfo: [],
    generalListInfo: [],
    generalListTotal: NaN,

    contractOrderInfo: [],

    contractOrderListInfo: [],
    contractOrderListTotal: NaN,

    //代理商报销列表
    expenseList: [],
    expenseTotal: 0,
    //代理商返佣
    rebateList: [],
    rebateTotal: 0,
    inviteAgentId: "",
    agentId: "",

    profitDetail: [],
    profitDetailTotal: 0,
    projectListInfo: [],
    getProjectList2Info: [],
    getProjectList2Total: 0,
    partnerProjectListInfo: [],
    generalListTotal: 0,
    userWalletRecords: [],
    userWalletDetailTotal: 0,
    userWallet: [],
  },
  mutations: {
    setConfigInfo(state, payload) {
      state.configInfo = payload;
    },
    setCoinConfList(state, payload) {
      state.coinConfListInfo = payload.list;
      state.coinConfListTotal = payload.totalCount;
    },
    setPreceptList(state, payload) {
      state.preceptListInfo = payload.list;
      state.preceptListTotal = payload.totalCount;
    },
    setAccountList(state, payload) {
      state.accountListInfo = payload;
    },
    setPreceptDataList(state, payload) {
      state.preceptDataListInfo = payload;
    },
    setOrderList(state, payload) {
      state.orderListInfo = payload.list;
      state.orderListTotal = payload.totalCount;
    },
    setBlastList(state, payload) {
      state.blastListInfo = payload.list;
      state.blastListTotal = payload.totalCount;
    },
    setOrderDetail(state, payload) {
      state.orderDetail = payload;
    },
    setContractAccountList(state, payload) {
      state.contractAccountListInfo = payload;
    },
    setGeneralList(state, payload) {
      state.generalListInfo = payload;
      state.generalListTotal = payload.totalCount || 0;
    },

    setProjectList2(state, payload) {
      state.getProjectList2Info = payload.list;
      state.getProjectList2Total = payload.totalCount || 0;
    },
    setpartnerProjectList(state, payload) {
      state.partnerProjectListInfo = payload.list;
      state.partnerProjectLisTotal = payload.totalCount || 0;
    },
    setProjectList(state, payload) {
      state.projectListInfo = payload.list;
    },

    setContractOrderList(state, payload) {
      state.contractOrderInfo = payload;
    },
    setContractHoldList(state, payload) {
      state.contractOrderListInfo = payload.list;
      state.contractOrderListTotal = payload.totalCount;
    },

    setExpenseInfo(state, payload) {
      state.expenseList = payload.list;
      state.expenseTotal = payload.totalCount;
    },
    setRebateInfo(state, payload) {
      state.rebateList = payload.list;
      state.rebateTotal = payload.totalCount;
    },
    setAgentId(state, payload) {
      state.agentId = payload;
    },

    setprofitDetaiList(state, payload) {
      state.profitDetail = payload.list;
      state.profitDetailTotal = payload.totalCount || 0;
    },
    setUserWalletRecords(state, payload) {
      state.userWalletRecords = payload.slice().map((item) => {
        return {
          ...item,
          __status:
            item.txType === 1
              ? DEPOSIT_STATUS_TYPE[item.txStatus]
              : STATUS_TYPE[item.txStatus],
        };
      });
    },
    setUserDetailTotal(state, payload) {
      state.userWalletDetailTotal = payload;
    },
    setUserWallet(state, payload) {
      state.userWallet = payload;
    },
  },
  actions: {
    //借贷宝
    getMortgageConfig({ commit }) {
      api.getMortgageConfig().then((response) => {
        commit("setConfigInfo", response.data);
      });
    },

    getCoinConfList({ commit }, data) {
      api.getCoinConfList(data).then((response) => {
        commit("setCoinConfList", response.data);
      });
    },

    getPreceptList({ commit }, data) {
      api.getPreceptList(data).then((response) => {
        commit("setPreceptList", response.data);
      });
    },

    getAccountList({ commit }, data) {
      api.getAccountList(data).then((response) => {
        commit("setAccountList", response.data);
      });
    },
    getPreceptDataList({ commit }, data) {
      api.getPreceptDataList(data).then((response) => {
        commit("setPreceptDataList", response.data);
      });
    },

    getOrderList({ commit }, data) {
      api.getOrderList(data).then((response) => {
        commit("setOrderList", response.data);
      });
    },

    getBlastList({ commit }, data) {
      api.getBlastList(data).then((response) => {
        commit("setBlastList", response.data);
      });
    },

    getOrderDetail({ commit }, data) {
      api.getOrderDetail(data).then((response) => {
        commit("setOrderDetail", response.data);
      });
    },
    getUserWallet({ commit }, data) {
      commit("setUserWallet", []);
      api.getUserWallet(data.userId).then(({ data }) => {
        commit("setUserWallet", data);
      });
    },
    //借贷宝结束

    //全币种合约
    getContractAccountList({ commit }, data) {
      api.getContractAccountList(data).then((response) => {
        commit("setContractAccountList", response.data);
      });
    },

    getGeneralList({ commit }, data) {
      api.getGeneralList(data).then((response) => {
        commit("setGeneralList", response.data);
      });
    },

    getProjectList({ commit }, data) {
      api.getProjectList(data).then((response) => {
        commit("setProjectList2", response.data);
      });
    },

    //关联的项目方列表
    partnerList({ commit }, data) {
      api.getpartnerProjectList(data).then((response) => {
        commit("setpartnerProjectList", response.data);
      });
    },

    //持仓管理列表
    getContractOrderList({ commit }, data) {
      api.getContractOrderList(data).then((response) => {
        commit("setContractOrderList", response.data);
      });
    },

    getProjectList2({ commit }, data) {
      api.getProjectList2(data).then((response) => {
        commit("setProjectList2", response.data);
      });
    },

    getHoldOrderList({ commit }, data) {
      api.getHoldOrderList(data).then((response) => {
        commit("setContractHoldList", response.data);
      });
    },

    //代理商
    getExpenseList({ commit }, data) {
      api.selectAgentStatement(data).then((response) => {
        commit("setExpenseInfo", response.data);
      });
    },
    getRebateList({ commit }, data) {
      api.selectAgentStatement(data).then((response) => {
        commit("setRebateInfo", response.data);
      });
    },
    commitAgentId({ commit }, data) {
      commit("setAgentId", data);
    },

    //分润
    getOrderProjectAccount({ commit }, data) {
      api.getOrderProjectAccount(data).then((response) => {
        commit("setprofitDetaiList", response.data);
      });
    },
  },
};

appStore.registerModule("FinanceManage", store);
